import { MutationTree } from "vuex";
import { ILangState } from "./interface";
import { TLang } from "@/models/modules/lang/interface";

export default <MutationTree<ILangState>> {

	setLang(state, newVal: TLang) {
		state.lang = newVal;
	}

}